define('../src/journeys/j1-parallax-scroll/j1-parallax-scroll',['jquery', 'lib/utils'], function($, utils) {

    'use strict';

    var J1_PARALLAX = function($journey) {

        this.$journey = $journey;

        return this;
    };

    J1_PARALLAX.prototype.init = function() {
        var _this = this,
            headToTop = _this.$journey.offset().top,
            scrollTitle = this.$journey.find('.scrolled');

        scrollTitle.each(function() {
           // $(this).attr('tempwidth', $(this).outerWidth(true));
           // $(this).attr('tempheight', $(this).outerHeight(true));
        });

        $(window).off('resize.j1p').on('resize.j1p', function () {
            headToTop = _this.$journey.offset().top;
            scrollTitle.each(function() {
               // $(this).attr('tempwidth', $(this).outerWidth(true));
               // $(this).attr('tempheight', $(this).outerHeight(true));
            });
        });

        _this.fix(scrollTitle, headToTop, _this.$journey);

        $(window).scroll(function() {
            _this.fix(scrollTitle, headToTop, _this.$journey);
        });
    };

    J1_PARALLAX.prototype.fix = function($element, toTop, elem) {
        var _this = this,
            winScroll = $(window).scrollTop() + 91,
            elemBottom = elem.height() + toTop - 540;

        if (winScroll > toTop && winScroll < elemBottom && $(window).outerWidth(true) > 1024) {
            $element.addClass('fixed');
            $element.removeClass('hidden')
                //_this.setWidth()
        } else {
            $element.removeClass('fixed')
        }
    };


    return J1_PARALLAX;
});

